import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { userAdminApi } from '@/api/recognition/client';
import type { SaveSyncSettingsBody, SyncSettingsDto } from '@/api/types';

const KEY = ['admin', 'sync-settings'] as const;

/** GET /v1/admin/sync-settings — fuentes de sincronización del tenant (PLAN §4.2). */
export function useSyncSettings() {
  return useQuery<SyncSettingsDto>({
    queryKey: KEY,
    queryFn: () => userAdminApi.getSyncSettings(),
  });
}

/**
 * PUT /v1/admin/sync-settings.
 *
 * Invalida también la lista de jobs: cambiar la fuente cambia cuáles van a correr de verdad
 * (con `ApiOnly`, por ejemplo, el del AD pasa a quedar omitido), y el tab tiene que reflejarlo
 * sin que haga falta recargar.
 */
export function useSaveSyncSettings() {
  const queryClient = useQueryClient();

  return useMutation<SyncSettingsDto, unknown, SaveSyncSettingsBody>({
    mutationFn: (body) => userAdminApi.saveSyncSettings(body),
    onSuccess: (saved) => {
      queryClient.setQueryData(KEY, saved);
      void queryClient.invalidateQueries({ queryKey: ['jobs'] });
    },
  });
}
